/*
 * Lucid pre-order buy box
 * - Keeps the product form's selling plan in sync with the customer's payment choice
 *   (PreOrder Globo uses Shopify selling plans; the plan decides deposit vs full payment).
 * - Hides Globo's own payment radios (optional, per block setting) so there is one control.
 * - Updates the button label with what is charged today.
 * - Re-renders on variant change using the section HTML the theme already fetches.
 * Safe if Globo is missing: nothing here calls Globo directly.
 */
(function () {
  "use strict";
  if (window.__lucidPreorderLoaded) return;
  window.__lucidPreorderLoaded = true;

  var choices = {}; // sectionId -> 'partial' | 'full'
  var labelObservers = {};
  var labelCache = {};
  var resizeObservers = {};

  function parts(id) {
    return {
      wrapper: document.getElementById("ProductInfo-" + id),
      box: document.getElementById("PreorderBox-" + id),
      note: document.getElementById("PreorderNote-" + id),
      form: document.getElementById("product-form-" + id),
      button: document.getElementById("ProductSubmitButton-" + id),
    };
  }

  function isComingSoon(p) {
    var scope = formScope(p.form);
    if (!scope) return false;

    return Array.prototype.some.call(
      scope.querySelectorAll(".gPreorderComingSoonBtnAddtocart"),
      isVisible,
    );
  }

  function isVisible(el) {
    if (!el) return false;

    for (
      var node = el;
      node && node !== document.body;
      node = node.parentElement
    ) {
      var cs = window.getComputedStyle(node);

      if (
        cs.display === "none" ||
        cs.visibility === "hidden" ||
        cs.visibility === "collapse" ||
        node.hidden
      ) {
        return false;
      }
    }

    return true;
  }

  function choiceInput(box, choice) {
    return box
      ? box.querySelector('input[data-lp-choice="' + choice + '"]')
      : null;
  }

  function formScope(form) {
    return (form && (form.closest("product-form") || form)) || null;
  }

  function fire(el, type) {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  }

  /* Point the product form at the selling plan for this choice. */
  function syncSellingPlan(form, choice, planId) {
    if (!form) return;
    var scope = formScope(form);
    var matched = false;
    var keyword =
      choice === "partial" ? /partial|deposit|reserve|pay later/i : /full/i;

    var radios = Array.prototype.filter.call(
      scope.querySelectorAll('input[type="radio"]'),
      function (r) {
        return !r.closest("[data-lp-box]");
      },
    );
    var labelText = function (r) {
      var label =
        r.closest("label") ||
        (r.id && scope.querySelector('label[for="' + r.id + '"]'));
      return (
        (label
          ? label.textContent
          : r.parentElement && r.parentElement.textContent) || ""
      );
    };
    // 1) the app's radio whose value is this selling plan, 2) otherwise the one labelled Full / Partial
    var target =
      radios.find(function (r) {
        return planId && r.value === String(planId);
      }) ||
      radios.find(function (r) {
        return keyword.test(labelText(r));
      });
    if (target) {
      if (!target.checked) {
        target.checked = true;
        fire(target, "change");
        fire(target, "click");
      }
      matched = true;
    }

    scope
      .querySelectorAll('select[name="selling_plan"]')
      .forEach(function (sel) {
        if (sel.value !== String(planId)) {
          sel.value = planId;
          fire(sel, "change");
        }
        matched = true;
      });

    var fields = form.querySelectorAll('[name="selling_plan"]');
    if (!fields.length && !matched) {
      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "selling_plan";
      hidden.setAttribute("data-lp-plan", "");
      form.appendChild(hidden);
      fields = [hidden];
    }
    fields.forEach(function (f) {
      if (f.type === "hidden") f.value = planId || "";
    });
  }

  function clearSellingPlan(form) {
    if (!form) return;

    var scope = formScope(form);

    scope.querySelectorAll('[name="selling_plan"]').forEach(function (field) {
      if (field.hasAttribute("data-lp-plan")) {
        field.remove();
        return;
      }

      if (field.type === "radio" || field.type === "checkbox") {
        field.checked = false;
      } else {
        field.value = "";
      }

      field.disabled = true;
      field.dataset.lpDisabledByExclusion = "true";
    });
  }

  function restoreSellingPlanFields(form) {
    if (!form) return;

    var scope = formScope(form);

    scope
      .querySelectorAll("[data-lp-disabled-by-exclusion]")
      .forEach(function (field) {
        field.disabled = false;
        delete field.dataset.lpDisabledByExclusion;
      });
  }
  /* Hide the app's own payment-option radios (ours replace them). */
  function hideAppPaymentUi(form) {
    var scope = formScope(form);
    if (!scope) return;
    var button = scope.querySelector('[type="submit"]');
    scope.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (r.closest("[data-lp-box]")) return;
      var container =
        r.closest(
          '[class*="globo"], [id*="globo"], [class*="preorder"], [id*="preorder"]',
        ) ||
        (r.parentElement && r.parentElement.parentElement);
      if (!container || container === form || container === scope) return;
      if (button && container.contains(button)) return;
      container.classList.add("lp-app-hidden");
    });
  }

  /* Hidden line-item property so the cart can show "Ships est. Nov 17". The leading
     underscore keeps it out of checkout and order emails. */
  function setShipDateProperty(form, shipDate) {
    if (!form) return;
    var input = form.querySelector('input[name="properties[_ship_date]"]');
    if (!shipDate) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_ship_date]";
      form.appendChild(input);
    }
    input.value = shipDate;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || "USD",
      }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function quantity(form) {
    var input =
      form &&
      document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    if (!input && form) input = form.querySelector('input[name="quantity"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  /* The visible submit button. Globo can hide the theme's button and show its own. */
  function findButton(p) {
    var scope = formScope(p.form);
    var list = [];
    if (p.button) list.push(p.button);
    if (scope) {
      scope
        .querySelectorAll(
          'button[type="submit"], button[name="add"], input[type="submit"]',
        )
        .forEach(function (b) {
          if (list.indexOf(b) === -1) list.push(b);
        });
    }
    var shown = list.filter(isVisible);
    return shown[0] || list[0] || null;
  }

  /* Where the words live: a plain span (not a spinner/icon), else the button itself. */
  function labelTarget(button) {
    var spans = button.querySelectorAll("span");
    for (var i = 0; i < spans.length; i++) {
      var cls = (spans[i].className || "") + "";
      if (/spinner|loading|icon|hidden/i.test(cls)) continue;
      if (spans[i].querySelector("svg")) continue;
      return spans[i];
    }
    return button;
  }

  /* Width a piece of text needs in the button's real font. Measured with a hidden copy
     outside the form, so the page's web font is used and the label observer isn't triggered. */
  var measurer = null;
  function textWidth(text, el) {
    if (!measurer) {
      measurer = document.createElement("span");
      measurer.setAttribute("aria-hidden", "true");
      measurer.style.cssText =
        "position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;pointer-events:none;";
      document.body.appendChild(measurer);
    }
    var cs = window.getComputedStyle(el);
    [
      "fontFamily",
      "fontSize",
      "fontWeight",
      "fontStyle",
      "letterSpacing",
      "textTransform",
      "fontStretch",
      "wordSpacing",
    ].forEach(function (k) {
      measurer.style[k] = cs[k];
    });
    measurer.textContent = text;
    return measurer.getBoundingClientRect().width;
  }

  /* Space inside the button for the label: its width minus padding and anything else in it
     (spinner, icon) that takes up room. */
  function labelRoom(button, target) {
    var bcs = window.getComputedStyle(button);
    var room =
      button.clientWidth -
      parseFloat(bcs.paddingLeft) -
      parseFloat(bcs.paddingRight);
    if (target !== button) {
      Array.prototype.forEach.call(button.children, function (child) {
        if (child === target || child.contains(target)) return;
        var ccs = window.getComputedStyle(child);
        if (
          ccs.position === "absolute" ||
          ccs.position === "fixed" ||
          ccs.display === "none"
        )
          return;
        room -= child.getBoundingClientRect().width;
      });
    }
    return room - 8; // small safety margin so the text never touches the edges
  }

  /* "Pre-order · Pay $168.75 today", shortened only when the button is too narrow. */
  function updateButtonLabel(id) {
    var p = parts(id);
    if (!p.box || p.box.dataset.cta !== "true") return;
    var button = findButton(p);
    if (!button || button.disabled) return;
    var input = choiceInput(p.box, choices[id]);
    if (!input) return;
    var amount = money(
      parseInt(input.dataset.cents, 10) * quantity(p.form),
      p.box.dataset.currency,
    );
    var prefix = p.box.dataset.ctaPrefix || "Pre-order";
    var candidates = [
      prefix + " · Pay " + amount + " today",
      "Pay " + amount + " today",
      prefix,
    ];

    var target = labelTarget(button);
    var isInput = button.tagName === "INPUT";
    var current = (isInput ? button.value : target.textContent).trim();
    // Only relabel our own labels or the app's pre-order label (never "Sold out" / "Unavailable").
    var ours =
      Object.keys(labelCache).some(function (k) {
        return labelCache[k] === current;
      }) || candidates.indexOf(current) !== -1;
    if (!ours && !/pre[\s-]?order|add to cart/i.test(current)) return;

    var room = labelRoom(button, isInput ? button : target);
    var text = candidates[candidates.length - 1];
    if (room > 0) {
      for (var i = 0; i < candidates.length; i++) {
        if (textWidth(candidates[i], isInput ? button : target) <= room) {
          text = candidates[i];
          break;
        }
      }
    } else {
      text = candidates[0];
    }
    labelCache[id + ":" + text] = text;

    if (current !== text) {
      if (isInput) button.value = text;
      else target.textContent = text;
      if (!isInput) button.setAttribute("aria-label", candidates[0]);
    }

    // The theme and Globo both rewrite this label; put ours back when they do.
    if (!labelObservers[id]) {
      labelObservers[id] = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          updateButtonLabel(id);
        });
      });
      var root = formScope(p.form) || button;
      labelObservers[id].observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["disabled", "style", "class"],
      });
      if (window.ResizeObserver) {
        resizeObservers[id] = new ResizeObserver(function () {
          updateButtonLabel(id);
        });

        resizeObservers[id].observe(button);
      }
    }
  }

  function apply(id) {
    var p = parts(id);
    if (!p.box) return;

    var comingSoon = isComingSoon(p);
    var preorderWrapper = p.box.closest(
      ".f-product-single__block--preorder_box",
    );
    var buyButtons = p.wrapper?.querySelector(
      ".f-product-single__block--buy_buttons",
    );

    if (preorderWrapper) {
      preorderWrapper.hidden = comingSoon;
    }
    if (p.note) {
      p.note.hidden = comingSoon;
    }
    if (buyButtons) {
      buyButtons.toggleAttribute("data-preorder-spacing", comingSoon);
    }
    if (comingSoon) {
      setShipDateProperty(p.form, "");
      clearSellingPlan(p.form);
      disconnectLabelObservers(id);
      return;
    }

    restoreSellingPlanFields(p.form);

    var choice = choices[id] || p.box.dataset.default || "partial";
    if (!choiceInput(p.box, choice))
      choice = choiceInput(p.box, "full") ? "full" : "partial";
    choices[id] = choice;

    if (p.wrapper) p.wrapper.dataset.lpChoice = choice;
    p.box.querySelectorAll("input[data-lp-choice]").forEach(function (input) {
      var on = input.dataset.lpChoice === choice;
      input.checked = on;
      var label = input.closest(".lp-option");
      if (label) label.classList.toggle("is-selected", on);
    });

    var input = choiceInput(p.box, choice);
    syncSellingPlan(p.form, choice, input ? input.dataset.planId : "");
    if (p.box.dataset.hideAppUi === "true") hideAppPaymentUi(p.form);
    setShipDateProperty(p.form, p.box.dataset.shipDate);
    updateButtonLabel(id);
  }

  function applyAll() {
    document.querySelectorAll("[data-lp-box]").forEach(function (box) {
      apply(box.dataset.sectionId);
    });
  }

  /* Customer picks a payment option */
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t.matches && t.matches("input[data-lp-choice]")) {
      var box = t.closest("[data-lp-box]");
      if (!box) return;
      choices[box.dataset.sectionId] = t.dataset.lpChoice;
      apply(box.dataset.sectionId);
    } else if (t.name === "quantity") {
      applyAll();
    }
  });
  document.addEventListener("input", function (e) {
    if (e.target && e.target.name === "quantity") applyAll();
  });

  /* "See our Pre-order FAQs below" */
  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest("[data-lp-faq]");
    if (!link) return;
    var hash = link.getAttribute("href") || "";
    var target = null;
    try {
      target = hash.charAt(0) === "#" ? document.querySelector(hash) : null;
    } catch (err) {}
    if (!target) target = document.querySelector('[id$="__faq"]');
    if (!target) return;
    e.preventDefault();
    var reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({
      behavior: reduce ? "auto" : "smooth",
      block: "start",
    });
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  });

  function disconnectLabelObservers(id) {
    if (labelObservers[id]) {
      labelObservers[id].disconnect();
      delete labelObservers[id];
    }

    if (resizeObservers[id]) {
      resizeObservers[id].disconnect();
      delete resizeObservers[id];
    }
  }

  /* Variant change: the theme fetches the section HTML; reuse it for our two pieces. */
  function onVariantChange(payload) {
    var data = payload && payload.data;
    if (!data || !data.html || !data.sectionId) return;
    ["PreorderBox-", "PreorderNote-"].forEach(function (prefix) {
      var fresh = data.html.getElementById(prefix + data.sectionId);
      var current = document.getElementById(prefix + data.sectionId);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      if (fresh && current && prefix === "PreorderBox-") {
        Array.prototype.forEach.call(fresh.attributes, function (a) {
          if (a.name.indexOf("data-") === 0)
            current.setAttribute(a.name, a.value);
        });
      }
    });
    apply(data.sectionId);
  }

  function subscribe() {
    if (window.FoxThemeEvents && window.FoxThemeEvents.subscribe) {
      window.FoxThemeEvents.subscribe("variant-change", onVariantChange);
      return true;
    }
    return false;
  }
  if (!subscribe()) document.addEventListener("DOMContentLoaded", subscribe);

  /* PreOrder Globo renders after load and re-renders on variant change. */
  [
    "globo.preorder.show.payment",
    "globo.preorder.show.preorder",
    "globo.preorder.show.addtocart",
  ].forEach(function (evt) {
    document.addEventListener(evt, function () {
      window.requestAnimationFrame(applyAll);
    });
  });
  window.addEventListener("preorderRendered", applyAll);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }
  window.addEventListener("load", applyAll);
  // Web fonts can finish loading after the first measurement; re-check the button label then.
  if (document.fonts && document.fonts.ready)
    document.fonts.ready.then(applyAll);
  if (document.fonts && document.fonts.addEventListener)
    document.fonts.addEventListener("loadingdone", applyAll);
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyAll, 100);
  });
  document.addEventListener("shopify:section:load", applyAll);
})();
